module.exports = __webpack_public_path__ + "img/Ia.b46dfec6.png";